const state = {
    count:2
}
export default state